import VirginImage from "images/devices/virgin.jpg"

export const Virgin = {
  id: "VIRGIN_ROUTER",
  img: VirginImage,
  name: "Virgin Media Hub 3",
  rating: 5,
  availableColors: ["black"],
  details: {
    title1: "Mighty WiFi, powered by our mighty Hub 3",
    text1:
      "With Intelligent WiFi technology unleashed on our Hub 3, we can bring faster WiFi speeds to hungry gadgets.​",
    title2: "Take control with just a few taps​",
    text2:
      "The latest Wi-Fi technology ensures more devices can get a superfast connection at the same time​",
    title3: "Help banish those WiFi blackspots ​",
    text3:
      "Got a WiFi blackspot in your home? A WiFi Booster can help boost WiFi signal in the room where you’ve plugged it in. Magic.​"
  }
}
